export default {
  groupManagement:{
    groupsdata: {

    },
    filter: {

    }
  }
}